import { ref } from "vue";

const EXTENSOES_PERMITIDAS = ["png", "jpg", "jpeg"];

export function useUploadImagem() {
  const nomeImagem = ref("");
  const preview = ref("");
  const imagemSelecionada = ref(false);
  const erro = ref("");

  function validarExtensao(file) {
    const extensao = file.name.split(".").pop().toLowerCase();
    return EXTENSOES_PERMITIDAS.includes(extensao);
  }

  function processarArquivo(file) {
    erro.value = "";
    if (!validarExtensao(file)) {
      erro.value = "Arquivo não permitido. Use PNG, JPG ou JPEG.";
      return Promise.resolve(null);
    }

    nomeImagem.value = file.name;

    return new Promise((resolve) => {
      const leitor = new FileReader();
      leitor.onload = () => {
        preview.value = leitor.result;
        imagemSelecionada.value = true;
        resolve({
          mimeType: file.type,
          base64Data: leitor.result.split(",")[1],
        });
      };
      leitor.readAsDataURL(file);
    });
  }

  function limpar() {
    nomeImagem.value = "";
    preview.value = "";
    imagemSelecionada.value = false;
    erro.value = "";
  }

  function carregarPreview(mimeType, base64Data, nome = "Imagem selecionada") {
    if (base64Data && mimeType) {
      preview.value = `data:${mimeType};base64,${base64Data}`;
      imagemSelecionada.value = true;
      nomeImagem.value = nome;
    } else if (
      typeof mimeType === "string" &&
      (mimeType.startsWith("http") || mimeType.startsWith("data:"))
    ) {
      preview.value = mimeType;
      imagemSelecionada.value = true;
      nomeImagem.value = nome;
    }
  }

  return {
    nomeImagem,
    preview,
    imagemSelecionada,
    erro,
    processarArquivo,
    carregarPreview,
    limpar,
  };
}
